import PromoCodePage from "../pages/PromoСodePage";
import ScriptsPage from "../pages/ScriptsPage";
import CourseManagementPage from "../pages/CourseManagementPage";
import CourseAddPage from "../pages/CourseAddPage";
import CourseEditPage from "../pages/CourseEditPage";
import SubjectsPage from "../pages/SubjectsPage";
import UsersPage from "../pages/Admiin/UsersPage/UsersPage";


const adminRoutes = [
    {
        index: true,
        path: '',
        Component: CourseManagementPage
    },
    {
        path: 'promocode',
        Component: PromoCodePage
    },
    {
        path: 'scripts',
        Component: ScriptsPage
    },
    {
        path: 'courses/add',
        Component: CourseAddPage
    },
    {
        path: 'courses/:id',
        Component: CourseEditPage
    },
    {
        path: 'subjects',
        Component: SubjectsPage
    },
    {
        path: 'users',
        Component: UsersPage
    }
]

export default adminRoutes